import { lazy } from 'react'
import Loadable from '../components/Loadable'
import Dashboard from '../layout/Dashboard'
import PrivateRoute from "./PrivateRoute"
import Profile from '../layout/Dashboard/Header/HeaderContent/Profile'

const DashboardDefault = Loadable(lazy(() => import('../pages/dashboard/index')))
const UsersPage = Loadable(lazy(() => import('../pages/users')))
const RolePage = Loadable(lazy(() => import('../pages/role')))
const PermissionPage = Loadable(lazy(() => import('../pages/permission')))
const RoleUserPage = Loadable(lazy(() => import('../pages/roleUser')))

const SchoolPage = Loadable(lazy(() => import('../pages/school')))

const ClassPage = Loadable(lazy(() => import('../pages/class')))
const ClassDetailPage = Loadable(lazy(() => import('../pages/class-detail')))

const ExamPage = Loadable(lazy(() => import('../pages/exam')))
const ExamDetailPage = Loadable(lazy(() => import('../pages/exam-detail')))
const DirectMockExamPage = Loadable(lazy(() => import('../pages/direct-mock-exam')))
const DirectMockExamResultsPage = Loadable(lazy(() => import('../pages/direct-mock-exam-results')))
const SettingPage = Loadable(lazy(() => import('../pages/setting')))

const QuestionPage = Loadable(lazy(() => import('../pages/question')))
const ExamPartPage = Loadable(lazy(() => import('../pages/exam-part')))
const ExamSkillPage = Loadable(lazy(() => import('../pages/exam-skill')))
const LevelPage = Loadable(lazy(() => import('../pages/level')))
const QuestionTypePage = Loadable(lazy(() => import('../pages/question-type')))
const AnswerOptionPage = Loadable(lazy(() => import('../pages/answer-options')))
const QuestionChildPage = Loadable(lazy(() => import('../pages/question-child')))
const UserProfile = Loadable(lazy(() => import('../pages/profile')))
const UserLevelPage = Loadable(lazy(() => import('../pages/user-level')))
const WriteTestReviewPage = Loadable(lazy(() => import('../pages/review-write-test')))
const ReviewPage = Loadable(lazy(() => import('../pages/review')))

const NotFoundPage = Loadable(lazy(() => import('../pages/error/notFoundPage')))

// ==============================|| MAIN ROUTING ||============================== //


const MainRoutes = {
  path: '/',
  element: <PrivateRoute element={<Dashboard />} />,  // Truyền vào element ở đây
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: '/review',
      element: <ReviewPage />
    },
    {
      path: '/write-test-review/:id',
      element: <WriteTestReviewPage />
    },
    {
      path: '*',
      element: <NotFoundPage />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    {
      path: 'class',
      element: <ClassPage />
    },
    {
      path: 'school',
      element: <SchoolPage />
    },
    {
      path: 'class-detail/:id',
      element: < ClassDetailPage />
    },
    {
      path: 'exam',
      element: <ExamPage />
    },
    {
      path: 'direct-mock-exam',
      element: <DirectMockExamPage />
    },
    {
      path: 'direct-mock-exam-results',
      element: <DirectMockExamResultsPage />
    },
    {
      path: 'user-level',
      element: <UserLevelPage />
    },
    {
      path: 'exam-detail/:id',
      element: <ExamDetailPage />
    },
    {
      path: 'question-child',
      element: <QuestionChildPage />
    },
    {
      path: 'exam-part',
      element: <ExamPartPage />
    },
    {
      path: 'answer-options',
      element: <AnswerOptionPage />
    },

    {
      path: 'question',
      element: <QuestionPage />
    },
    {
      path: 'exam-skill',
      element: <ExamSkillPage />
    },
    {
      path: 'level',
      element: <LevelPage />
    },
    {
      path: 'question-type',
      element: <QuestionTypePage />
    },
    {
      path: 'role',
      element: <RolePage />
    },
    {
      path: 'permission',
      element: <PermissionPage />
    },
    {
      path: 'users',
      element: <UsersPage />
    },
    {
      path: 'role-user',
      element: <RoleUserPage />
    },
    {
      path: '/change-password',
      element: <UserProfile />
    },
    {
      path: '/profile',
      element: <UserProfile />
    },
    {
      path: '/setting',
      element: <SettingPage />
    },
  ]
}

export default MainRoutes
